/**
 * @deprecated
 * @returns {string}
 */
export const randomString = () =>
  Math.random()
    .toString(36)
    .substring(2, 15) +
  Math.random()
    .toString(36)
    .substring(2, 15)

/**
 * Generates a random string based on the optionally provided length and allowed characters
 * @param length Length of desired string
 * @param allowed Provided allowed characters
 * @returns {string}
 */
export const getRandomString = (
  length = 10,
  allowed = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
) => {
  return Array(length)
    .join()
    .split(',')
    .map(() => {
      return allowed.charAt(Math.floor(Math.random() * allowed.length))
    })
    .join('')
}

/**
 * Generates a random number where the maximum is inclusive and the minimum is inclusive
 * @param min Minimum inclusive value
 * @param max Maximum inclusive value
 * @returns {number}
 */
export const getRandomIntInclusive = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Generates a random Boolean value
 * @returns {boolean}
 */
export const getRandomBoolean = () => {
  return Boolean(Math.round(Math.random()))
}

/**
 * Determines if inspect is a promise or not
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isPromise = inspect => {
  return isObject(inspect) && isFunction(inspect.then)
}

/**
 * Determines if inspect is async or not
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isAsync = inspect => {
  return (
    typeof isFunction(inspect) && inspect.constructor.name === 'AsyncFunction'
  )
}

/**
 * Determines if inspect is not defined
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isNotDefined = inspect => {
  return typeof inspect === 'undefined' || inspect === null
}

/**
 * Determines if inspect is defined
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isDefined = inspect => {
  return !isNotDefined(inspect)
}

/**
 * Determines if inspect is an object or not
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isObject = inspect => {
  return isDefined(inspect) && typeof inspect === 'object'
}

/**
 * Determines if inspect is a function or not
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isFunction = inspect => {
  return isDefined(inspect) && typeof inspect === 'function'
}

/**
 * Determines if inspect is an Array or not
 * @param inspect Item to inspect
 * @returns {boolean}
 */
export const isArray = inspect => {
  return isDefined(inspect) && Array.isArray(inspect)
}

/**
 * Deep merge method will merge all source object into
 * the target based on the targets object tree by key
 * @param {object} target
 * @param {...object} sources
 */
export function mergeDeep (target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}
